import { Breadcrumb } from 'components/Breadcrumb';
import { Button } from 'components/core';
import { PersonalizeCase, TemplateMode } from 'components/PersonalizeCase';
import { useI18n } from 'contexts/i18n';
import { FC, useState } from 'react';
import { ClamShellTemplate } from 'types';
import { ClamshellTemplate, ClamshellTemplateListingProps, Styled } from './';

const ClamshellTemplateListing: FC<ClamshellTemplateListingProps> = ({
  clamshellTemplates,
}) => {
  const getMode = () => {
    return clamshellTemplates && clamshellTemplates.length > 0
      ? 'list'
      : 'create';
  };
  const [templateMode, setTemplateMode] = useState<TemplateMode>(getMode());
  const [selectedTemplate, setSelectedTemplate] = useState<ClamShellTemplate>();
  const i18n = useI18n();
  const modeDescription = {
    create: 'Create Design',
    edit: 'Edit Design',
    select: 'Select Back Case Design',
    clone: 'Clone  Design',
  };

  return (
    <>
      {(templateMode === 'create' ||
        templateMode === 'edit' ||
        templateMode === 'clone' ||
        templateMode === 'select') && (
        <>
          <Breadcrumb
            items={[
              {
                name: 'Custom Clamshell',
                permalink: '/customcase',
                id: 0,
                level: 0,
              },
              {
                name: modeDescription[templateMode],
                permalink: '',
                id: -1,
                level: -1,
              },
            ]}
          />
          <PersonalizeCase
            setTemplateMode={setTemplateMode}
            templateMode={templateMode}
            selectedTemplate={selectedTemplate}
          />
        </>
      )}
      {templateMode === 'list' && (
        <Styled.TemplateListingContainer>
          <Breadcrumb
            items={[
              {
                name: 'Custom Clamshell',
                permalink: '/customcase',
                id: 0,
                level: 0,
              },
              {
                name: i18n['Select Back Case Design'],
                permalink: '',
                id: -1,
                level: -1,
              },
            ]}
          />

          <Styled.TemplateListingHeader>
            <Styled.HeaderTitle>{i18n['Your saved templates']}</Styled.HeaderTitle>
            <Button onClick={() => setTemplateMode('create')}>
              {i18n['Create New Template']}
            </Button>
          </Styled.TemplateListingHeader>

          <Styled.TemplateListingBody>
            {clamshellTemplates &&
              clamshellTemplates.map(template => {
                return (
                  <ClamshellTemplate
                    clamshellTemplate={template}
                    setSelectedTemplate={setSelectedTemplate}
                    setTemplateMode={setTemplateMode}
                    key={template.id}
                  />
                );
              })}
          </Styled.TemplateListingBody>
        </Styled.TemplateListingContainer>
      )}
    </>
  );
};

export default ClamshellTemplateListing;
